import React from 'react';
import { useInfluencerPosts } from '../../hooks/useInfluencerPosts';
import { Skeleton } from '@/components/ui/skeleton';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { PostListRow } from './PostListRow';

interface ExpandedPostsPanelProps {
  campaignInfluencerId: string;
  isExpanded: boolean;
  influencerFollowers: number | null;
}

export const ExpandedPostsPanel: React.FC<ExpandedPostsPanelProps> = ({
  campaignInfluencerId,
  isExpanded,
  influencerFollowers,
}) => {
  const { data: posts = [], isLoading } = useInfluencerPosts(
    isExpanded ? campaignInfluencerId : null
  );

  if (!isExpanded) return null;

  if (isLoading) {
    return (
      <div className="p-4 bg-muted/30 border-t">
        <div className="space-y-2">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-10 rounded" />
          ))}
        </div>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="p-4 bg-muted/30 border-t text-center text-muted-foreground">
        No posts yet for this influencer.
      </div>
    );
  }

  return (
    <div className="bg-muted/30 border-t">
      <Table className="table-fixed">
        <colgroup>
          <col className="w-[19%]" />
          <col className="w-[8%]" />
          <col className="w-[8%]" />
          <col className="w-[8%]" />
          <col className="w-[9%]" />
          <col className="w-[8%]" />
          <col className="w-[9%]" />
          <col className="w-[11%]" />
          <col className="w-[10%]" />
          <col className="w-[9%]" />
          <col className="w-[9%]" />
        </colgroup>
        <TableHeader>
          <TableRow className="text-xs">
            <TableHead className="py-2 text-xs pl-8">Platform</TableHead>
            <TableHead className="py-2 text-xs text-center">Type</TableHead>
            <TableHead className="py-2 text-xs text-center">Views</TableHead>
            <TableHead className="py-2 text-xs text-center">Likes</TableHead>
            <TableHead className="py-2 text-xs text-center">Comments</TableHead>
            <TableHead className="py-2 text-xs text-center">Shares</TableHead>
            <TableHead className="py-2 text-xs text-center">Post Eng.</TableHead>
            <TableHead className="py-2 text-xs text-center">ER% Followers</TableHead>
            <TableHead className="py-2 text-xs text-center">ER% Views</TableHead>
            <TableHead className="py-2 text-xs text-center">View Rate</TableHead>
            <TableHead className="py-2 text-xs text-center">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {posts.map((post) => (
            <PostListRow key={post.id} post={post} influencerFollowers={influencerFollowers} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
